<template>
  <!-- <div class="internship-challenge-bg"> -->
  <div class="internship-challenge">
    <div v-if="cookieObj.pageStatus === 0" class="upload-box">
      <div class="logo">
        <img :src="logoImg" width="100%">
      </div>
      <div class="upload-content">
        <h2>{{ title[0] }}<br>{{ title[1] }}</h2>
        <p>恭喜您已成功递交所有答题选项！<br>
          为确保您的分数以及CV及时同步至offer端，<br>
          请在本页面完成您的CV提交<br>
          提交简历后可获取本轮测试分数及下载官方完成证明
        </p>
        <div style="width: 75%">
          <van-uploader v-model="fileList" accept="" multiple :max-size="5 * 1024 * 1024" :max-count="5" upload-text="上传简历" upload-icon="plus" :before-read="beforeRead" @oversize="onOversize" />
        </div>
        <button class="btn" @click="afterRead">提交简历</button>
        <p style="color: #999; font-size:.24rem">注：可接受小于5M的图片或PDF文件,最多可分成5份<br>如无法上传，请使用浏览器打开上传</p>
        <img :src="illuImg" width="40%" style="margin: 0 auto">
      </div>
    </div>
    <div ref="shaBox">
      <div v-if="cookieObj.pageStatus === 1" class="sha-box" :class="bg">
        <div class="avatar">
          <van-uploader ref="uploadAvatar" v-model="avatarList" accept="image/*" upload-text="头像" :deletable="!previewMode" :preview-full-image="false" :max-size="5 * 1024 * 1024" :max-count="1" @oversize="onOversize" />
        </div>
        <div class="body-heading">
          <p v-show="cookieObj.language">
            亲爱的 <strong>{{ userName }}</strong>，
            <br>恭喜你成功上传简历并完成了
            <br>本次 {{ title[0] }}<br>{{ title[1] }} 能力测试，<br>获得
            <span class="trophy" /><strong class="large">{{ score }}分</strong> 的结果。
          </p>
          <p v-show="cookieObj.language">
            要相信，那些你为游向岸边而付出的努力，<br>
            都将有它的意义！<br>
            <strong class="large">加油吧少年！</strong>
          </p>
          <p v-show="!cookieObj.language" style="font-size: .38rem;">
            Dear <strong>{{ userName }}</strong><br>
            <strong>Congratulations!</strong> <br>
            You’ve successfully uploaded <br>your resume &amp; completed the
            <strong>Online Test Session of {{ title[0] }}&nbsp;{{ title[1] }}</strong><br>
            Your total score is <span class="trophy" /><strong class="large">{{ score }}</strong>.
          </p>
          <p v-show="!cookieObj.language" style="font-size: .38rem;"><strong>Always keep in mind that,<br>
            All the efforts you made will <br>Eventually pay off one day.</strong></p>
          <button v-if="cookieObj.pageStatus === 1 && !previewMode" class="btn-lang" @click="changeLang">{{ cookieObj.language ? 'En' : '中文' }}</button>
        </div>
        <div class="body-text">
          <h4 v-if="!previewMode">想知道当日全国分数打榜，猜测自己可能的排位？</h4>
          <div ref="inputBox" class="input-box" contenteditable="true">#预定我的offer# @普华永道YouPlus特训计划 OMG 我的分数是{{ score }}分！9月10日到12日都可以做题，还没开始做题的朋友们可要做好大脑过山车的准备了！</div>
          <p v-if="!previewMode" class="explain">
            输入你的感想，点“保存”按钮保存此图，<br>
            晒出你的分数与挑战感言，<br>
            在微博上搜索或发布贴子带上话题 #预定我的offer#，<br>
            参与并了解当日最高分挑战！
          </p>
        </div>
        <div class="foot-qrcode">
          <div>
            <h4>{{ title[0] }}</h4>
            <h4>{{ title[1] }}</h4>
          </div>
          <img :src="qrCodeImg">
        </div>
      </div>
      <div v-if="cookieObj.pageStatus === 2" class="award-box">
        <img :src="awardImg" class="award-img">
        <div class="award-text">
          <!-- <p>This certificate is awarded to</p> -->
          <!-- <p>&nbsp;</p> -->
          <div class="name">{{ userName }}</div>
          <!-- <p>for the successful completion in</p>
          <div class="title">{{ title[0] }}<br>{{ title[1] }}</div>
          <div class="test">Online Test Session</div>
          <div class="present">Presented</div>
          <div class="present">by PwC You Plus</div>
          <div class="present">Sept, 2020</div> -->
        </div>
      </div>
    </div>
    <div class="download-btn">
      <button v-if="cookieObj.pageStatus === 1" class="btn1" @click="createPoster">生成海报图片</button>
      <button v-if="cookieObj.pageStatus === 2" class="btn2" @click="generateImg">生成证书图片</button>
    </div>
    <!-- <div class="copyright font-yahei">© {{ copyrightYear }} PwC. 普华永道版权所有。未经允许，严禁使用</div> -->
    <van-popup v-model="showPopup" :close-on-click-overlay="false" closeable :lock-scroll="true" :style="{ padding: '.2rem .2rem' }" @close="closePopup">
      <img :src="imgUrl" :width="imgWidth-80" height="auto">
      <div v-show="cookieObj.pageStatus === 1" style="color:#d93954; text-align: center;">长按图片保存至手机；关闭弹框后可生成证书</div>
      <div v-show="cookieObj.pageStatus === 2" style="color:#d93954; text-align: center;">长按图片保存至手机</div>
    </van-popup>
  </div>
  <!-- </div> -->
</template>
<script>
import { common } from '../common/mixin.js'
export default {
  mixins: [common]
}
</script>
<style>
.internship-challenge .van-uploader__upload,
.internship-challenge .van-uploader__preview-image {
  width: 1.6rem;
  height: 1.6rem;
}
.internship-challenge .sha-box .van-uploader__upload,
.internship-challenge .sha-box .van-image {
  border-radius: 50%;
}
.internship-challenge .van-uploader__preview-image img {
  min-height: 100%;
  height: auto;
}
.internship-challenge {
  position: relative;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: 0.4rem;
  font-size: 0.28rem;
  line-height: 170%;
}
.internship-challenge .upload-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
}
.internship-challenge .btn {
  width: 2.4rem;
  min-height: 35px;
  height: 0.7rem;
  margin: 0.2rem 0;
  border-radius: 0.44rem;
  border: 1px solid #d04a02;
  color: #d04a02;
  line-height: 0.7rem;
}
.internship-challenge .btn:hover,
.internship-challenge .btn:active {
  background-color: #d04a02;
  color: #fff;
}
.internship-challenge .upload-box .logo {
  height: auto;
  margin: 0.6rem 1.6rem 0.4rem;
}
.internship-challenge .upload-box .upload-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  flex-grow: 1;
  padding-bottom: 1.4rem;
}
.internship-challenge .upload-box .upload-content h2 {
  margin-bottom: 0.3rem;
  font-size: 0.44rem;
  line-height: 130%;
  font-family: Georgia, 'Microsoft Yahei';
}
.internship-challenge .upload-box .upload-content p {
  margin-bottom: 0.2rem;
  color: #444;
}
.internship-challenge .sha-box {
  position: relative;
  /* min-height: 100vh; */
  background: #281a23 url(./../../../assets/internship-challenge-bg.jpg) center top no-repeat;
  background-size: 100% auto;
}
.internship-challenge .sha-box.bg-2 {
  background-color: #232532;
  background-image: url(./../../../assets/internship-challenge-bg2.jpg);
}
.internship-challenge .sha-box.bg-3 {
  background-color: #1a1c1e;
  background-image: url(./../../../assets/internship-challenge-bg3.jpg);
}
.internship-challenge .sha-box.bg-4 {
  background-color: #161e28;
  background-image: url(./../../../assets/internship-challenge-bg4.jpg);
}
.internship-challenge .sha-box.bg-5 {
  background-color: #1d1d1c;
  background-image: url(./../../../assets/internship-challenge-bg5.jpg);
}
.internship-challenge .avatar {
  float: right;
  width: 1.6rem;
  height: 1.6rem;
  margin: 0.4rem 0.4rem 0.1rem 0.1rem;
}
.internship-challenge .body-heading {
  padding: 0.4rem;
  color: #fff;
  font-size: 0.34rem;
  line-height: 180%;
}
.internship-challenge .body-heading p {
  margin-bottom: 0.8em;
}
.internship-challenge .body-heading .fa {
  margin-right: 0.04rem;
  font-size: 0.48rem;
}
.internship-challenge .body-heading .large {
  font-size: 2em;
  line-height: 150%;
}
.internship-challenge .body-heading .trophy {
  display: inline-block;
  width: 0.48rem;
  height: 0.64rem;
  background: url(./../../../assets/internship-challenge-trophy.png) 100% 0 no-repeat;
  background-size: auto 100%;
  vertical-align: text-bottom;
}
.internship-challenge button.btn-lang {
  left: 0.4rem;
  top: 8rem;
  width: 0.6rem;
  height: 0.6rem;
  color: #fff;
  font-size: 0.2rem;
  line-height: 0.6rem;
  background-color: rgba(0, 0, 0, 0.9);
}
.internship-challenge .body-text {
  padding: 0 0.4rem 1.6rem;
}
.internship-challenge .body-text h4 {
  color: #fff;
  font-weight: normal;
}
.internship-challenge .input-box {
  margin: 0.2rem 0;
  padding: 0.24rem 0.3rem;
  color: #111;
  font-size: 0.28rem;
  background-color: #fff;
  border-radius: 0.08rem;
}
.internship-challenge .explain {
  margin: 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.24rem;
  line-height: 150%;
}
.internship-challenge .foot-qrcode {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.2rem;
  background-color: #000;
  font-family: Georgia, sans-serif;
}
.internship-challenge .foot-qrcode h4 {
  color: #fff;
  font-size: 0.24rem;
  font-weight: normal;
}
.internship-challenge .foot-qrcode h5 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.2rem;
  font-weight: normal;
  line-height: 150%;
}
.internship-challenge .foot-qrcode img {
  width: 1rem;
}
.internship-challenge .award-box {
  position: relative;
  width: 100vw;
  height: 133.33vw;
}
.internship-challenge .award-box img {
  position: relative;
  width: 100%;
  height: 100%;
  vertical-align: bottom;
}
.internship-challenge .award-box .award-text {
  position: absolute;
  z-index: 11;
  width: 100%;
  bottom: 49%;
  text-align: center;
}
.internship-challenge .award-box .award-text p {
  font-size: 0.24rem;
  margin-bottom: 0.16rem;
}
.internship-challenge .award-box .award-text .name {
  margin-bottom: 0.28rem;
  font-size: 0.48rem;
  font-family: Georgia, 'Microsoft Yahei' !important;
}
.internship-challenge .award-box .award-text .title {
  margin-bottom: 0.12rem;
  color: #e0301e;
  font-size: 0.48rem !important;
  font-family: Georgia !important;
}
.internship-challenge .award-box .award-text .test {
  margin-bottom: 0.7rem;
  font-size: 0.32rem;
  font-family: Georgia !important;
}
.internship-challenge .award-box .award-text .present {
  font-size: 0.24rem;
  text-align: right;
}
.internship-challenge .download-btn {
  display: flex;
  align-items: center;
  margin-top: 0.3rem;
  width: 100%;
  padding: 0 0.4rem;
}
.internship-challenge .download-btn button {
  flex-grow: 1;
  height: 1rem;
  color: #fff;
  font-size: 0.4rem;
  border-radius: 0.5rem;
}
.internship-challenge .download-btn button.btn1 {
  background-color: #ffb600;
}
.internship-challenge .download-btn button.btn1:hover,
.internship-challenge .download-btn button.btn1:active {
  background-color: #eb8c00;
}
.internship-challenge .download-btn button.btn2 {
  background-color: #d93954;
}
.internship-challenge .download-btn button.btn2:hover,
.internship-challenge .download-btn button.btn2:active {
  background-color: #d04a02;
}

/* .internship-challenge .copyright {
  color: #777;
  font-size: .24rem;
  text-align: center;
} */
</style>
